import React, { FC, useCallback } from 'react'
import FilterPills from './FilterPills'

const AdvancedListingTypeFilter: FC<{
    listingType: string[]
    listingTypeOptions: string[]
    handleClick: (listingType: string[]) => void
}> = ({ listingType, handleClick, listingTypeOptions }) => {
    const handleListingTypeFilterClick = useCallback(
        (lType: string) => () => {
            if (listingType.includes(lType)) {
                handleClick(listingType.filter((value) => value !== lType))
                return
            }

            handleClick([...listingType, lType])
        },
        [listingType, handleClick]
    )

    return (
        <>
            {listingTypeOptions.map((ltype) => (
                <FilterPills
                    data-testid={`listingDialog_advancedFilters_${ltype}`}
                    buttonText={ltype}
                    key={ltype}
                    handleClick={handleListingTypeFilterClick(ltype)}
                    isActive={listingType.includes(ltype)}
                />
            ))}
        </>
    )
}

export default AdvancedListingTypeFilter
